import type { InvoiceStatus } from '../type/types';

const KNOWN_INVOICE_STATUSES: readonly InvoiceStatus[] = [
    'Draft',
    'Sent',
    'Expired',
    'Cancelled',
    'Accepted',
    'Issued',
    'PartialPaid',
    'Paid',
    'Overdue',
    'Refunded',
];

/**
 * Mirrors Invoice::isQuote() in PHP — quote phase follows status; when Cancelled, declined quotes
 * have QuoteDecisionDate set and voided invoices do not.
 */
export const isInvoiceQuote = (
    status: string | null | undefined,
    quoteDecisionDate?: string | null,
): boolean => {
    if (status == null || status === '') {
        return true;
    }
    if (status === 'Cancelled') {
        return (
            quoteDecisionDate != null && String(quoteDecisionDate).trim() !== ''
        );
    }
    if (['Draft', 'Sent', 'Expired'].includes(status)) {
        return true;
    }
    if (!KNOWN_INVOICE_STATUSES.includes(status as InvoiceStatus)) {
        return true;
    }
    return false;
};

/** Proposal UI document label: quote vs invoice, aligned with isInvoiceQuote. */
export const getDocType = (
    status: InvoiceStatus,
    quoteDecisionDate?: string | null,
): 'quote' | 'invoice' =>
    isInvoiceQuote(status, quoteDecisionDate) ? 'quote' : 'invoice';
